import { useTranslation } from 'react-i18next'
import '../../assets/scss/page-high-gain/property-card.scss'
import Icon from '../Icon'
import Currency from '../Currency'
import { Row, Col } from 'react-bootstrap'
import ImgCdn from '../shared/ImgCdn'
import get from 'lodash.get'
import Link from 'next/link'
import { emitGA } from '~/utils/gtm'

const PropertyCard = (props) => {
  const [t] = useTranslation()
  const p = props.property || {}
  const apartment = p.apartment_info || {}
  // apartment
  const {
    area,
    bathroom,
    bedroom,
    num_of_floor: numOfFloor
  } = apartment

  // property
  const {
    property_class: propertyClass,
    featured_image: img,
    estimated_return: profit,
    seo_friendly_url: seoUrl,
    name,
    id: propertyId
  } = p

  // offer
  const {
    id,
    number_viewing: viewer,
    promotion,
    num_of_shares: totalShares,
    property_price: price,
    shares_left: shareLeft,
    payment_types: paymentTypes,
    priority,
  } = props
  const pricePerShare = (price / totalShares).toFixed(0)
  const isHorizontal = props.cardType === 'horizontal'
  const isBackupOffer = (id === '5eec638b063b350a99b484bd')
  const backupVinwonderSold =  22

  const sendGA = () => {
    if (props.GACategory) {
      emitGA(props.GACategory, { action: 'ViewProperty', label: name })
    }
  }

  return (
    <Link href={`property-detail?propertyId=${propertyId}`} as={seoUrl}>
      <div onClick={sendGA} className={`property-card-container ${isHorizontal ? 'pc_horizontal' : ''}`} style={{ cursor: 'pointer' }}>
        {/* banner image */}
        <div className='pc__banner'>
          <div className='img'>
            <img width='100%' alt="" src={img} />
          </div>
          {priority === 'hot' && <img src="/images/hot.png" className="pc_hot" alt="" />}
          {paymentTypes &&
            paymentTypes[0] &&
            paymentTypes[0].value > 0 && (
            <div className='pc__promotion-label flex'>
              <ImgCdn src='/img/promotion.svg' />
              <span>{t`Lợi nhuận`}</span>
              <span className='bold'>{t`ƯU ĐÃI`}</span>
            </div>
          )}
        </div>
        <div className='pc__info-container'>
          {/* info */}
          <div className='pc__info'>
            <div className='center title fz-26'>
              {name}
            </div>
            <div className='flex'>
              {
                propertyClass !== 'shophouse' ?
                  <>
                    <p>
                      <Icon name='bed' />
                      {bedroom}
                    </p>
                    <p>
                      <Icon name='bath' />
                      {bathroom}
                    </p>
                  </>
                  :
                  <>
                    <p>
                      <Icon name='house' />
                      {numOfFloor} {t`tầng`}
                    </p>
                  </>
              }
              <p>
                <Icon name='square' />
                {area}{' '}
                {propertyClass !== 'shophouse' && 'm2'}
              </p>

              <p>
                <Icon name='location' />
                {get(p, 'address.locality')}
              </p>
            </div>
          </div>

          {/* price per share */}
          {shareLeft > 0
            ? (
              <div className='c-primary pc__price-per-share center'>
                <Currency value={pricePerShare} className='fz-22 bold' />
                <span> {t`/phần`}</span>
              </div>
            )
            : (
              <div className='fz-22 bold c-red pc__price-per-share center'>
                {t`Đã bán hết`}
              </div>
            )
          }

          {/* investment info */}
          <Row className='pc__investment-info'>
            <Col xs={6}>
              {isHorizontal && <Icon name='house' style={{ fontSize: 24 }} />}
              <p>{t`Giá bán từ CĐT`}</p>
              <p><Currency value={price} /></p>
            </Col>
            <Col xs={6}>
              {isHorizontal && <Icon name='gain' style={{ fontSize: 24 }} />}
              <p>{t`Tiềm năng`}</p>
              <p className='c-green' >{profit}</p>
            </Col>
            {!isBackupOffer &&
              <>
                <Col xs={6}>
                  {isHorizontal && <Icon name='total-share' style={{ fontSize: 24 }} />}
                  <p>{t`Tổng số phần`}</p>
                  <p>{totalShares}</p>
                </Col>
                <Col xs={6}>
                  {isHorizontal && <Icon name='selected-share' style={{ fontSize: 24 }} />}
                  <p>{t`Số phần đã bán`}</p>
                  <p>{totalShares && totalShares - shareLeft}</p>
                </Col>
              </>
            }
            {isBackupOffer &&
              <>
                <Col xs={12} style={{ backgroundColor: 'white' }}>
                  {isHorizontal && <Icon name='selected-share' style={{ fontSize: 24 }} />}
                  <p>{t`Số phần cọc thiện chí`}</p>
                  <p>{backupVinwonderSold}</p>
                </Col>
              </>
            }
          </Row>

          {/* status bar of remained share */}
          {!isBackupOffer ?
            <>
              {(shareLeft / totalShares < 0.7) &&
                <div className='pc__status-bar'>
                    <span style={{maxWidth: '50%', marginRight: 10}} className='remained-share-status-bar'>
                      <span style={{width: `${(totalShares - shareLeft) * 100 / totalShares}%`}}/>
                    </span>
                  <div className='fz-12'>
                    {t`Còn lại:`}
                    {' '}
                    <span className='bold c-primary fz-16'>{shareLeft}</span>
                    {' '}
                    {t`phần`}
                  </div>
                </div>
              }
            </>
            :
            <div className="card_footer p-2 fz-12">
              <i><strong>Ghi chú:</strong> Khi cọc thiện chí bạn sẽ được đưa vào danh sách chờ. Cọc càng sớm càng được ưu tiên mua phần đầu tư mới.</i>
            </div>
          }
        </div>
      </div>
    </Link>
  )
}

export default PropertyCard
